var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pension",
    clipPath: "url(#clip0_5830_854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M3.27922 20.8796C4.63559 21.5896 5.86822 22.17 7.01107 22.618M22.1458 18.6319C21.3426 19.3429 20.5833 19.978 19.8552 20.5383M7.01107 22.618L10.0759 14.531M7.01107 22.618C12.0706 24.6014 15.3703 23.9896 19.8552 20.5383M19.8552 20.5383L15.5373 13.8803M19.5092 13.4071L6.6005 14.945L2.37945 4.87362",
    stroke: "#6E6E6E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M13.5 4.29803V2.79803H11M8.5 7.79803V9.29803H11M11 2.79803H8.5V6.04803H13.5V9.29803H11M11 2.79803V0.798035M11 9.29803V11.298",
    stroke: "#14AA3C",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5830_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.798035)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario3);
export default __webpack_public_path__ + "static/media/Scenario3.d6922763557fb55c5bb276a5fb98e41c.svg";
export { ForwardRef as ReactComponent };